import {ActionReducerMap, Action} from '@ngrx/store';

import * as actionsUi from './mandantenverwaltung-typspezifikation.actions.ui';
import { APP_RESET_ACTION } from '@orga-app/appstart/actions';
import {PandemieVeranstaltungTypKonfiguration, PandemieVeranstaltungTypKonfigurationMandantOptions} from '../../../clients/pandemie';
import {GET_MANDANT_CONFIG, GET_MANDANT_CONFIG_ERFOLGREICH, GET_MANDANT_CONFIG_FEHLER, GetMandantConfigErfolgreichAction} from '../../../client-ngrx/api';
import {PandemieConfigTypes} from '../../../client-constants';
import PANDEMIE_TYP_KONFIGURATION_OPTIONS = PandemieConfigTypes.PANDEMIE_VERANSTALTUNG_TYP_KONFIGURATION_MANDANT_OPTIONS;
import {FunktionsbereichRolle, VeranstaltungsTyp, VeranstaltungsTypFeld, VeranstaltungsTypFeldSelectOption, VeranstaltungsTypDetail} from '../../../clients/veranstaltungstypen';
import {
    GET_VERANSTALTUNGS_TYP_ADMIN_ROLLEN, GET_VERANSTALTUNGS_TYP_ADMIN_ROLLEN_ERFOLGREICH, GET_VERANSTALTUNGS_TYP_ADMIN_ROLLEN_FEHLER, GET_VERANSTALTUNGS_TYP_DETAIL, GET_VERANSTALTUNGS_TYP_DETAIL_ERFOLGREICH, GET_VERANSTALTUNGS_TYP_DETAIL_FEHLER,
    GET_VERANSTALTUNGS_TYP_FELDER, GET_VERANSTALTUNGS_TYP_FELDER_ERFOLGREICH, GET_VERANSTALTUNGS_TYP_FELDER_FEHLER,
    GET_VERANSTALTUNGS_TYPEN,
    GET_VERANSTALTUNGS_TYPEN_ERFOLGREICH,
    GET_VERANSTALTUNGS_TYPEN_FEHLER, GetVeranstaltungsTypAdminRollenErfolgreichAction, GetVeranstaltungsTypDetailErfolgreichAction,
    GetVeranstaltungsTypenErfolgreichAction, GetVeranstaltungsTypFelderErfolgreichAction,
    POST_VERANSTALTUNGS_TYP_ADMIN_ROLLE_ENTFERNEN_ERFOLGREICH,
    POST_VERANSTALTUNGS_TYP_ANLEGEN, POST_VERANSTALTUNGS_TYP_FELD_ANLEGEN,
    PostVeranstaltungsTypAnlegenAction, PostVeranstaltungsTypFeldAnlegenAction
} from '../../../client-ngrx/veranstaltungstypen';
import {ADMIN_ROLLEN_SETZEN, AdminRollenSetzenAction} from './mandantenverwaltung-typspezifikation.actions.ui';

export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};


export interface PageState {
    mandantConfigLaden: boolean;
    mandantConfigFehler: boolean;

    pandemieTypConfig: PandemieVeranstaltungTypKonfigurationMandantOptions;
    selectedPandemieTypConfig: PandemieVeranstaltungTypKonfiguration;

    veranstaltungsTypen: Array<VeranstaltungsTyp>;
    veranstaltungsTypenLaden: boolean;
    veranstaltungsTypenFehler: boolean;

    selectedTyp: VeranstaltungsTyp;

    selectedTypDetail: VeranstaltungsTypDetail;
    selectedTypDetailLaden: boolean;
    selectedTypDetailFehler: boolean;

    selectedTypAdminRollen: Array<FunktionsbereichRolle>;
    selectedTypAdminRollenLaden: boolean;
    selectedTypAdminRollenFehler: boolean;

    selectedTypSelectedAdminRollen: Array<string>;

    selectedTypFelder: Array<VeranstaltungsTypFeld>;
    selectedTypFelderLaden: boolean;
    selectedTypFelderFehler: boolean;

    selectedTypFeld: VeranstaltungsTypFeld;
    selectedTypFeldOriginal: VeranstaltungsTypFeld;

    selectedTypFeldSelectedFeldOption: VeranstaltungsTypFeldSelectOption;
}

export const initialPageState: PageState = {
    mandantConfigLaden: false,
    mandantConfigFehler: false,

    pandemieTypConfig: null,
    selectedPandemieTypConfig: null,

    veranstaltungsTypen: [],
    veranstaltungsTypenLaden: false,
    veranstaltungsTypenFehler: false,

    selectedTyp: null,

    selectedTypDetail: null,
    selectedTypDetailLaden: false,
    selectedTypDetailFehler: false,

    selectedTypAdminRollen: [],
    selectedTypAdminRollenLaden: false,
    selectedTypAdminRollenFehler: false,

    selectedTypSelectedAdminRollen: [],

    selectedTypFelder: [],
    selectedTypFelderLaden: false,
    selectedTypFelderFehler: false,

    selectedTypFeld: null,
    selectedTypFeldOriginal: null,

    selectedTypFeldSelectedFeldOption: null

};


export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // APP RESET
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState>initialPageState);
        }

        // Page State Reset
        case actionsUi.PAGE_STATE_RESET: {
            return Object.assign({}, state, <PageState> initialPageState);
        }

        case GET_MANDANT_CONFIG: {
            return Object.assign({}, state, <PageState> {
                mandantConfigLaden: true,
                mandantConfigFehler: false
            });
        }

        case GET_MANDANT_CONFIG_ERFOLGREICH: {
            const a = <GetMandantConfigErfolgreichAction> action;

            let pandemieTypConfig: PandemieVeranstaltungTypKonfigurationMandantOptions = Object.assign({}, state.pandemieTypConfig);
            if (a.payload[PANDEMIE_TYP_KONFIGURATION_OPTIONS] !== undefined && a.payload[PANDEMIE_TYP_KONFIGURATION_OPTIONS] !== null) {
                pandemieTypConfig = a.payload[PANDEMIE_TYP_KONFIGURATION_OPTIONS];
            }

            return Object.assign({}, state, <PageState> {
                mandantConfigLaden: false,
                mandantConfigFehler: false,

                pandemieTypConfig
            });
        }

        case GET_MANDANT_CONFIG_FEHLER: {
            return Object.assign({}, state, <PageState> {
                mandantConfigLaden: false,
                mandantConfigFehler: true
            });
        }

        // Liste der Veranstaltungs-Typen
        case GET_VERANSTALTUNGS_TYPEN: {
            return Object.assign({}, state, <PageState> {
                veranstaltungsTypenLaden: true,
                veranstaltungsTypenFehler: false
            });
        }

        case GET_VERANSTALTUNGS_TYPEN_ERFOLGREICH: {
            const a = <GetVeranstaltungsTypenErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                veranstaltungsTypenLaden: false,
                veranstaltungsTypenFehler: false,
                veranstaltungsTypen: a.payload,
            });
        }

        case GET_VERANSTALTUNGS_TYPEN_FEHLER: {
            return Object.assign({}, state, <PageState> {
                veranstaltungsTypenLaden: false,
                veranstaltungsTypenFehler: true
            });
        }

        case actionsUi.VERANSTALTUNGS_TYP_GEWAEHLT: {
            const a = <actionsUi.VeranstaltungsTypGewaehlt> action;

            const selectedPandemieTyp = state.pandemieTypConfig.typen.find(x => x.veranstaltungstyp_id === a.payload.veranstaltungstyp_id);

            return Object.assign({}, state, <PageState> {
                selectedTyp: a.payload,
                selectedPandemieTypConfig: selectedPandemieTyp,
                selectedTypSelectedAdminRollen: [],
                selectedTypFeld: null
            });
        }

        // SelectedTypStamm laden
        case GET_VERANSTALTUNGS_TYP_DETAIL: {
            return Object.assign({}, state, <PageState> {
                selectedTypDetailLaden: true,
                selectedTypDetailFehler: false
            });
        }

        case GET_VERANSTALTUNGS_TYP_DETAIL_ERFOLGREICH: {
            const a = <GetVeranstaltungsTypDetailErfolgreichAction> action;

            let selectedTypDetail: VeranstaltungsTypDetail = null;

            if (state.selectedTypFelder !== null) {
                let anzeigeFeld1 = a.payload.anzeige_feld_1;
                let anzeigeFeld2 = a.payload.anzeige_feld_2;
                let anzeigeFeld3 = a.payload.anzeige_feld_3;

                state.selectedTypFelder.forEach(feld => {
                    if (anzeigeFeld1 !== null && anzeigeFeld1 !== undefined && anzeigeFeld1.search('{{' + feld.feld_id + '}}') > -1) {
                        anzeigeFeld1 = anzeigeFeld1.replace('{{' + feld.feld_id + '}}', '{{' + feld.titel + '}}');
                    }
                    if (anzeigeFeld2 !== null && anzeigeFeld2 !== undefined && anzeigeFeld2.search('{{' + feld.feld_id + '}}') > -1) {
                        anzeigeFeld2 = anzeigeFeld2.replace('{{' + feld.feld_id + '}}', '{{' + feld.titel + '}}');
                    }
                    if (anzeigeFeld3 !== null && anzeigeFeld3 !== undefined && anzeigeFeld3.search('{{' + feld.feld_id + '}}') > -1) {
                        anzeigeFeld3 = anzeigeFeld3.replace('{{' + feld.feld_id + '}}', '{{' + feld.titel + '}}');
                    }
                });
                selectedTypDetail = Object.assign({}, a.payload, <VeranstaltungsTypDetail> {
                    anzeige_feld_1: anzeigeFeld1,
                    anzeige_feld_2: anzeigeFeld2,
                    anzeige_feld_3: anzeigeFeld3
                });
            } else {
                selectedTypDetail = a.payload;
            }

            return Object.assign({}, state, <PageState> {
                selectedTypDetail,
                selectedTypDetailLaden: false,
                selectedTypDetailFehler: false
            });
        }

        case GET_VERANSTALTUNGS_TYP_DETAIL_FEHLER: {
            return Object.assign({}, state, <PageState> {
                selectedTypDetailLaden: false,
                selectedTypDetailFehler: true
            });
        }

        case actionsUi.VERANSTALTUNGS_TYP_HINZUFUEGEN: {
            const selectedTypDetail: VeranstaltungsTypDetail = {
                veranstaltungstyp_id: null,
                bezeichnung: '',
                ist_aktionen_sichtbar: false,
                ist_beginn_sichtbar: false,
                ist_einlass_sichtbar: false,
                ist_veranstaltungsleitung_sichtbar: false,
                ist_deaktiviert: false
            };

            return Object.assign({}, state, <PageState> {
                selectedTypDetail,
                selectedTyp: null
            });
        }

        case actionsUi.VERANSTALTUNGS_TYP_STAMM_INPUT: {
            const a = <actionsUi.VeranstaltungsTypStammInput> action;

            return Object.assign({}, state, <PageState> {
                selectedTypDetail: a.payload
            });
        }

        case POST_VERANSTALTUNGS_TYP_ANLEGEN: {
            const a = <PostVeranstaltungsTypAnlegenAction> action;

            const selectedTyp = Object.assign({}, state.selectedTyp, <VeranstaltungsTyp> {
                veranstaltungstyp_id: a.veranstaltungsTypStammRequest.veranstaltungstyp_id
            });

            return Object.assign({}, state, <PageState> {
                selectedTyp
            });
        }

        // VeranstaltunsTyp Berechtigungen
        case GET_VERANSTALTUNGS_TYP_ADMIN_ROLLEN: {
            return Object.assign({}, state, <PageState> {
                selectedTypAdminRollenLaden: true,
                selectedTypAdminRollenFehler: false
            });
        }

        case GET_VERANSTALTUNGS_TYP_ADMIN_ROLLEN_ERFOLGREICH: {
            const a = <GetVeranstaltungsTypAdminRollenErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                selectedTypAdminRollen: a.payload,
                selectedTypAdminRollenLaden: false,
                selectedTypAdminRollenFehler: false
            });
        }

        case GET_VERANSTALTUNGS_TYP_ADMIN_ROLLEN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                selectedTypAdminRollen: null,
                selectedTypAdminRollenLaden: false,
                selectedTypAdminRollenFehler: true
            });
        }

        case ADMIN_ROLLEN_SETZEN: {
            const a = <AdminRollenSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                selectedTypSelectedAdminRollen: a.payload
            });
        }

        case POST_VERANSTALTUNGS_TYP_ADMIN_ROLLE_ENTFERNEN_ERFOLGREICH: {
            return Object.assign({}, state, <PageState>{
                selectedTypSelectedAdminRollen: []
            });
        }

        // VeranstaltungsTyp Felder
        case GET_VERANSTALTUNGS_TYP_FELDER: {
            return Object.assign({}, state, <PageState> {
                selectedTypFelderLaden: true,
                selectedTypFelderFehler: false
            });
        }

        case GET_VERANSTALTUNGS_TYP_FELDER_ERFOLGREICH: {
            const a = <GetVeranstaltungsTypFelderErfolgreichAction> action;

            let selectedTypDetail: VeranstaltungsTypDetail = null;

            if (state.selectedTypDetail !== null) {
                let anzeigeFeld1 = state.selectedTypDetail.anzeige_feld_1;
                let anzeigeFeld2 = state.selectedTypDetail.anzeige_feld_2;
                let anzeigeFeld3 = state.selectedTypDetail.anzeige_feld_3;

                a.payload.forEach(feld => {
                    if (anzeigeFeld1 !== null && anzeigeFeld1.search('{{' + feld.feld_id + '}}') > -1) {
                        anzeigeFeld1 = anzeigeFeld1.replace('{{' + feld.feld_id + '}}', '{{' + feld.titel + '}}');
                    }
                    if (anzeigeFeld2 !== null && anzeigeFeld2.search('{{' + feld.feld_id + '}}') > -1) {
                        anzeigeFeld2 = anzeigeFeld2.replace('{{' + feld.feld_id + '}}', '{{' + feld.titel + '}}');
                    }
                    if (anzeigeFeld3 !== null && anzeigeFeld3.search('{{' + feld.feld_id + '}}') > -1) {
                        anzeigeFeld3 = anzeigeFeld3.replace('{{' + feld.feld_id + '}}', '{{' + feld.titel + '}}');
                    }
                });
                selectedTypDetail = Object.assign({}, state.selectedTypDetail, <VeranstaltungsTypDetail> {
                    anzeige_feld_1: anzeigeFeld1,
                    anzeige_feld_2: anzeigeFeld2,
                    anzeige_feld_3: anzeigeFeld3
                });
            }

            return Object.assign({}, state, <PageState> {
                selectedTypDetail,
                selectedTypFelder: a.payload,
                selectedTypFelderLaden: false,
                selectedTypFelderFehler: false
            });
        }

        case GET_VERANSTALTUNGS_TYP_FELDER_FEHLER: {
            return Object.assign({}, state, <PageState> {
                selectedTypFelderLaden: false,
                selectedTypFelderFehler: true
            });
        }

        case actionsUi.VERANSTALTUNGS_TYP_FELD_GEWAEHLT: {
            const a = <actionsUi.VeranstaltungsTypFeldGewaehlt> action;

            return Object.assign({}, state, <PageState> {
                selectedTypFeld: a.payload,
                selectedTypFeldOriginal: a.payload,
                selectedTypFeldSelectedFeldOption: null
            });
        }

        case actionsUi.VERANSTALTUNGS_TYP_FELD_INPUT: {
            const a = <actionsUi.VeranstaltungsTypFeldInput> action;

            return Object.assign({}, state, <PageState> {
                selectedTypFeld: a.payload
            });
        }

        case actionsUi.VERANSTALTUNGS_TYP_FELD_HINZUFUEGEN: {
            const selectedTypFeld: VeranstaltungsTypFeld = {
                veranstaltungstyp_id: null,
                titel: '',
                feld_id: null,
                typ: 'TEXT',
                ist_deaktiviert: false
            };

            return Object.assign({}, state, <PageState> {
                selectedTypFeld
            });
        }

        case actionsUi.VERANSTALTUNGS_TYP_FELD_EINGABE_ABBRECHEN: {
            let ret: VeranstaltungsTypFeld = state.selectedTypFeldOriginal;
            if (state.selectedTypFeldOriginal === null) {
                ret = null;
            }
            return Object.assign({}, state, <PageState> {
                selectedTypFeld: ret
            });
        }

        case POST_VERANSTALTUNGS_TYP_FELD_ANLEGEN: {
            const a = <PostVeranstaltungsTypFeldAnlegenAction> action;

            const selectedTypFeld = Object.assign({}, state.selectedTypFeld, <VeranstaltungsTypFeld> {
                feld_id: a.veranstaltungsTypFeldRequest.feld_id
            });

            return Object.assign({}, state, <PageState> {
                selectedTypFeld
            });
        }

        case actionsUi.VERANSTALTUNGS_TYP_FELD_SELECT_OPTION_GEWAEHLT: {
            const a = <actionsUi.VeranstaltungsTypFeldSelectOptionGewaehlt> action;

            return Object.assign({}, state, <PageState> {
                selectedTypFeldSelectedFeldOption: a.payload
            });
        }

        case actionsUi.VERANSTALTUNGS_TYP_FELD_SELECT_OPTION_LOESCHEN: {
            const a = <actionsUi.VeranstaltungsTypFeldSelectOptionLoeschen> action;

            const selectedTypFeld = Object.assign({}, state.selectedTypFeld);

            if (selectedTypFeld !== null) {
                const options = Object.assign([], selectedTypFeld.select_options);
                const index = options.findIndex(x => x.option_id === a.payload.option_id);

                options.splice(index, 1);

                selectedTypFeld.select_options = options;
            }

            return Object.assign({}, state, <PageState> {
                selectedTypFeld
            });
        }

        case actionsUi.VERANSTALTUNGS_TYP_FELD_SELECT_OPTION_SPEICHERN: {
            const a = <actionsUi.VeranstaltungsTypFeldSelectOptionSpeichern> action;

            const selectedTypFeld = Object.assign({}, state.selectedTypFeld);

            // console.log('Feld: ', selectedTypFeld);
            // console.log('speichern: ', selectedTypFeld);

            if (selectedTypFeld !== null) {
                const options = Object.assign([], selectedTypFeld.select_options);
                const index = options.findIndex(x => x.option_id === a.payload.option_id);
                // console.log('index: ', index);
                if (index === -1) {
                    // Hinzufügen
                    options.push(a.payload);
                } else {
                    options.splice(index, 1, a.payload);
                    // options.push(a.payload);
                }
                selectedTypFeld.select_options = options;
            }

            return Object.assign({}, state, <PageState> {
                selectedTypFeld
            });
        }

        case actionsUi.PANDEMIE_SCHWELLENWERTE_CONFIG_INPUT: {
            const a = <actionsUi.PandemieSchwellenwerteConfigInput> action;
            const selectedPandemieTypConfig = Object.assign({}, state.selectedPandemieTypConfig, { schwellenwerte: a.payload });

            return Object.assign({}, state, <PageState> {
                selectedPandemieTypConfig
            });
        }

        case actionsUi.PANDEMIE_LANDKREISE_CONFIG_INPUT: {
            const a = <actionsUi.PandemieLandkreiseConfigInput> action;
            const selectedPandemieTypConfig = Object.assign({}, state.selectedPandemieTypConfig, { landkreise: a.payload });

            return Object.assign({}, state, <PageState> {
                selectedPandemieTypConfig
            });
        }

        default: {
            return state;
        }
    }
}
